import React from 'react';
import { connect } from 'react-redux';
import { selectTimeDifference } from './timeSyncReducer';

const TimeSyncWrapper = WrappedComponent => {
  class TimeSynchronization extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = state => ({
    timeDifference: selectTimeDifference(state)
  });

  return connect(mapStateToProps)(TimeSynchronization);
};

export default TimeSyncWrapper;
